import fr from '../translations/fr.json';
export default fr;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/fr.js